import { render, staticRenderFns } from "./AscTabTitle.vue?vue&type=template&id=8c67c56c&"
import script from "./AscTabTitle.vue?vue&type=script&lang=js&"
export * from "./AscTabTitle.vue?vue&type=script&lang=js&"
import style0 from "./AscTabTitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
installComponents(component, {VIcon,VTab})
